import { A as r } from "./leaf-element.4609dd44.js";
const l = (o) => o != null ? o : r;
export {
  l
};
